module.exports = __webpack_public_path__ + "static/media/users.59f65954.svg";